import { Link } from 'react-router-dom';
import './notfaund.css'
function NotFaund(){
return(
  <div className='principal'>
    <h1>404</h1>
  <h2>Página não ncontrada</h2>
  <Link to="/">Ver todos Filmes!</Link>
  </div>
)
}
export default NotFaund;